import React from 'react';

export function replaceNewLinesWithBr(str: string): React.ReactElement {
  const splitStr = str.split('\n');
  const splitStrWithBrs = [];
  for (let i = 0; i < splitStr.length; i++) {
    splitStrWithBrs.push(splitStr[i]);
    splitStrWithBrs.push(<br key={i}></br>);
  }
  splitStrWithBrs.pop();
  return <>{splitStrWithBrs}</>;
}
